export default "__VITE_ASSET__5aa20de7__"